export default __webpack_public_path__ + "static/media/contact-3.a79d9001.svg";